export default __webpack_public_path__ + "static/media/ZTICMA.3b4f1fa8.png";